import classNames from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import EvaAudioLogo from '@/shared/assets/eva-audio-logo.svg?react';

import styles from './index.module.scss';

type Props = {
  readonly children: ReactNode;
  /**
   * `login`:登录卡(436px,固定最小高度 514,两个 tab 同尺寸不跳动);
   * `wide`:重置密码卡(496px,高度随内容);
   * 不设:436px 高度随内容。
   */
  readonly variant?: 'login' | 'wide';
};

/** EVA 卡片外壳:白卡 + logo + 欢迎语。登录卡与重置密码卡共用。 */
const EvaCardShell = ({ children, variant }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        styles.card,
        variant === 'login' && styles.login,
        variant === 'wide' && styles.wide
      )}
    >
      <div className={styles.header}>
        <EvaAudioLogo
          className={styles.logo}
          role="img"
          aria-label="EVA Audio"
          data-testid="eva-logo"
        />
        <h1 className={styles.subtitle}>{t('eva_domestic.welcome')}</h1>
      </div>
      {children}
    </div>
  );
};

export default EvaCardShell;
